import(/* webpackMode: "eager" */ "/app/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["MetaPixelEvents"] */ "/app/apps/web/src/components/meta-pixel/MetaPixelEvents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegister"] */ "/app/apps/web/src/components/pwa/ServiceWorkerRegister.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_react-_cbb1d25331cde32d05160a94ecf959f7/node_modules/next/dist/client/script.js");
